module.exports = "<div class=create-organization> <organization-new-card on-save=$ctrl.onOrganizationSave(organization)></organization-new-card> </div> ";